import { Control, Controller } from 'react-hook-form';
import BrandAutocompleteInput from './BrandAutocompleteInput';
import { Option } from '@/components/inputs/AutocompleteInput';

export interface FormBrandAutocompleteInputProps {
  name: string;
  placeholder: string;
  control: Control<any>;
  value?: Option | null;
  onChange: (newValue: Option | null) => void;
  onInputChange: (newValue: string) => void;
  required?: boolean;
  showCreateButton?: boolean;
}

const FormBrandAutocompleteInput = ({
  name,
  placeholder,
  control,
  value,
  onChange,
  onInputChange,
  required = false,
  showCreateButton = true,
}: FormBrandAutocompleteInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={() => (
        <BrandAutocompleteInput
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onInputChange={onInputChange}
          required={required}
          showCreateButton={showCreateButton}
        />
      )}
    />
  );
};

export default FormBrandAutocompleteInput; 